const timeDifference = (a, b) => {
  const elapsed = a < b ? b - a : a - b
  const difference = new Date(elapsed)
  const totalMinutes = difference.getUTCMinutes() > 0 ? (difference.getUTCMinutes() / 60) : 0
  const totalTime = difference.getUTCHours() + totalMinutes

  return totalTime
}

const getHoliday = async (start, end, holidays) => {
  const startDate = start.split(" ")[0]
  const endDate = end.split(" ")[0]

  return holidays.includes(startDate) || holidays.includes(endDate)
}

const getEve = async (end, endStr, eves) => eves.includes(endStr.split(" ")[0]) && end.getHours() > 20

const timeAt = (hours, minutes, seconds, initDate = new Date(), nextDay = false, days = 1) => {
  const date = new Date(initDate)
  if (nextDay) {
    date.setDate(initDate.getDate() + days)
  }
  const offset = date.getTimezoneOffset() / 60
  date.setUTCHours(hours + offset, minutes, seconds, 0)
  return date
}

const calcOverHours = (total, base, price) => {
  if (total <= base) {
    return false
  }
  const overHours = {
    total: total % base,
    totalEarned: 0,
  }
  if (overHours.total > 2) {
    const overHours50 = 2 % overHours.total
    const overHours100 = overHours.total - overHours50
    overHours.first = {
      hours: overHours50,
      earned: overHours50 * (price * 0.5),
    }
    overHours.second = {
      hours: overHours100,
      earned: overHours100 * price,
    }
    overHours.totalEarned = overHours.first.earned + overHours.second.earned
  } else {
    overHours.first = {
      hours: overHours.total,
      earned: overHours.total * (price * 0.5),
    }
    overHours.totalEarned = overHours.first.earned
  }
  return overHours
}

const calcHoursBetween = (start, end, from, to) => {
  let hours = 0
  if (start >= to || end <= from) {
    return null
  }
  hours = timeDifference(start > from ? start : from, end < to ? end : to)
  return hours
}

const calcWithCondition = (start, end, from, to, price, condition) => {
  let { hours, earned } = 0
  const roundedPrice = Math.ceil(price * 100) / 100
  if (!condition(start) && !condition(end)) {
    return null
  }
  hours = calcHoursBetween(start, end, from, to)
  if (hours > 0) {
    earned = hours * roundedPrice
  }
  return { hours, earned, price }
}

const isWeekDay = time => {
  if (time.getDay() > 0 && time.getDay() < 6) {
    return true
  }
  return false
}
const isSaturday = time => {
  if (time.getDay() === 6) {
    return true
  }
  return false
}

function getThreeWeekPeriod(date) {
  const startDate = new Date('2023-06-05')
  const endDate = new Date(date.getFullYear(), 11, 31)
  const millisecondsInThreeWeeks = 3 * 7 * 24 * 60 * 60 * 1000

  let periodStart = startDate.getTime()
  let periodEnd = periodStart + millisecondsInThreeWeeks

  while (periodEnd <= endDate.getTime() && date >= new Date(periodEnd)) {
    periodStart = periodEnd
    periodEnd += millisecondsInThreeWeeks
  }

  return {
    start: new Date(periodStart),
    end: new Date(periodEnd - 1)
  }
}

/* const isNotSaturday = time => {
  if (time.getDay() !== 6) {
    return true
  }
  return false
} */
const isSunday = time => {
  if (time.getDay() === 0) {
    return true
  }
  return false
}

const calculateTotalHours = shifts => {
  let totalHours = 0
  shifts.forEach(shift => {
    const hours = timeDifference(shift.start, shift.end)
    totalHours += hours
  })
  return totalHours
}

const calculateOverHoursInPeriod = (shifts, maxHours) => {
  const totalHours = calculateTotalHours(shifts)
  const overHours = totalHours - maxHours
  if (overHours > 0) {
    return overHours
  }
  return 0
}

const calculateShift = (start, end, pricePerHour, isHoliday = false, isEveningHoliday = false, unpaidTime = 0, isPublic = false) => {
  let totalTime = timeDifference(start, end)
  const baseHours = 8
  if (unpaidTime > 0 && totalTime >= baseHours) {
    totalTime -= (unpaidTime / 60)
  }
  const baseEarning = totalTime * pricePerHour
  const report = {}
  report.perus = {
    hours: totalTime,
    earned: baseEarning,
  }
  let yoLisaStart
  let lauantaiIltaLisaStart
  let lauantaiLisaPerc
  // Public TES
  if (isPublic) {
    yoLisaStart = 22
    lauantaiIltaLisaStart = 18
    lauantaiLisaPerc = 0.20
  } else { // Private tes
    yoLisaStart = 21
    lauantaiIltaLisaStart = 20
    lauantaiLisaPerc = 0.25
  }
  report.totalEarned = baseEarning
  const weekDay = isWeekDay(start) ? start : end
  const saturday = isSaturday(start) ? start : end
  const sunday = isSunday(start) ? start : end
  const iltaLisa = calcWithCondition(start, end, timeAt(18, 0, 0, weekDay), timeAt(yoLisaStart, 0, 0, weekDay), pricePerHour * 0.15, () => true)
  const yoLisa = calcWithCondition(start, end, timeAt(yoLisaStart, 0, 0, start), timeAt(6, 0, 0, start, true), pricePerHour * 0.30, () => true)
  const lauantaiLisa = calcWithCondition(start, end, timeAt(6, 0, 0, saturday), timeAt(lauantaiIltaLisaStart, 0, 0, saturday), pricePerHour * lauantaiLisaPerc, isSaturday)
  const lauantaiIltaLisa = calcWithCondition(start, end, timeAt(lauantaiIltaLisaStart, 0, 0, saturday), timeAt(23, 59, 59, saturday, true), pricePerHour, time => isSaturday(time) && !isHoliday)
  const sunnuntaiLisa = calcWithCondition(start, end, timeAt(lauantaiIltaLisaStart, 0, 0, sunday, true, -1), timeAt(23, 59, 59, sunday), pricePerHour, isSunday)
  const holidayLisa = calcWithCondition(start, end, timeAt(0, 1, 1, start), timeAt(23, 59, 59, start), pricePerHour, () => (isHoliday))
  const eveningHolidayLisa = calcWithCondition(start, end, timeAt(20, 0, 0, start), timeAt(23, 59, 59, start), pricePerHour, () => (isEveningHoliday))
  const overHours = calcOverHours(totalTime, baseHours, pricePerHour)
  if (iltaLisa && iltaLisa.hours > 0) {
    report.iltaLisa = iltaLisa
    report.totalEarned += iltaLisa.earned
  }
  if (yoLisa && yoLisa.hours > 0) {
    report.yoLisa = yoLisa
    report.totalEarned += yoLisa.earned
  }
  if ((lauantaiLisa && lauantaiLisa.hours > 0) && !isHoliday) {
    report.lauantaiLisa = lauantaiLisa
    report.totalEarned += lauantaiLisa.earned
  }
  if (!isHoliday && ((lauantaiIltaLisa && lauantaiIltaLisa.hours > 0) || (sunnuntaiLisa && sunnuntaiLisa.hours > 0))) {
    report.sunnuntaiLisa = lauantaiIltaLisa
  }
  if (sunnuntaiLisa && sunnuntaiLisa.hours > 0) {
    report.sunnuntaiLisa = sunnuntaiLisa
  }
  if (holidayLisa && holidayLisa.hours > 0) {
    report.sunnuntaiLisa = holidayLisa
    report.isHoliday = true
  }
  if (eveningHolidayLisa && eveningHolidayLisa.hours > 0) {
    report.sunnuntaiLisa = eveningHolidayLisa
    report.isHoliday = true
  }
  if (overHours) {
    report.ylityo = overHours
    report.totalEarned += overHours.totalEarned
  }
  if (report.sunnuntaiLisa) {
    report.totalEarned += report.sunnuntaiLisa.earned
  }
  return report
}

const numberToArray = n => n.toString(10).replace(/\D/g, '0').split('').map(Number)
const pad = (num, size) => {
  let s = num.toString()
  while (s.length < size) s = `0${s}`
  return s
}
const viiteCalculator = (n1, n2) => {
  const arr = numberToArray(n1)
  arr.push(0)
  arr.push(...numberToArray(n2))
  const multipliers = [7, 3, 1]
  let result = 0
  arr.forEach((digit, index) => {
    result += digit * multipliers[index % 3]
  })
  return result
}
const createViitenumero = (customerNumber, numOfInvoices) => {
  const n = viiteCalculator(customerNumber, numOfInvoices)
  const ceil = Math.ceil(n / 10) * 10
  const invoiceNumber = pad(numOfInvoices, 4)
  const laskuNumero = `${customerNumber}0 ${invoiceNumber}`
  const viiteNumero = `${laskuNumero}${ceil - n}`
  return { laskuNumero, viiteNumero }
}

export {
  calculateShift,
  getThreeWeekPeriod,
  calculateOverHoursInPeriod,
  createViitenumero,
  getHoliday,
  getEve,
}
